var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sv_01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4998 45.0001H26.5398C28.4598 45.0001 29.6999 43.6402 29.3399 41.9802L28.5198 38.3604H19.5198L18.6998 41.9802C18.3398 43.5402 19.6998 45.0001 21.4998 45.0001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5202 38.3404L31.9803 35.2603C33.9202 33.5403 34.0003 32.3401 32.4603 30.4002L26.3602 22.6603C25.0803 21.0403 22.9803 21.0403 21.7003 22.6603L15.6003 30.4002C14.0602 32.3401 14.0602 33.6003 16.0803 35.2603L19.5403 38.3404",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M24.0197 22.2402V27.3003",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.3 10.3798L20.74 8.81974C19.8 7.87974 19.8 6.35985 20.74 5.41984L22.3 3.85978C23.2401 2.91979 24.76 2.91979 25.7001 3.85978L27.2601 5.41984C28.2 6.35985 28.2 7.87974 27.2601 8.81974L25.7001 10.3798C24.76 11.3198 23.2401 11.3198 22.3 10.3798Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.8998 19.6204H41.0999C42.4199 19.6204 43.4999 20.7004 43.4999 22.0204V24.2204C43.4999 25.5404 42.4199 26.6205 41.0999 26.6205H38.8998C37.5798 26.6205 36.5 25.5404 36.5 24.2204V22.0204C36.5 20.7004 37.5798 19.6204 38.8998 19.6204Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.1 19.6204H6.9C5.58 19.6204 4.5 20.7004 4.5 22.0204V24.2204C4.5 25.5404 5.58 26.6205 6.9 26.6205H9.1C10.42 26.6205 11.5 25.5404 11.5 24.2204V22.0204C11.5 20.7004 10.42 19.6204 9.1 19.6204Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.4,
    d: "M37.08 20.2L26.4801 9.6001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.4,
    d: "M10.92 20.2L21.52 9.6001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui-ux.d60116639c09f2dca8e9f90c3b215e96.svg";
export { ForwardRef as ReactComponent };